import { lazy, Suspense } from "react";
import type { CreationExploration, CreationFilters } from "./creationExploration";
import { creationChangeWording } from "./creationChangeWording";

const WrittenChange = lazy(() => import("./CreationChangeWritten"));

/** Same component and cache in L2/L3; filters/mode produce a new factual packet. */
export function CreationChangeSummary({ source, filters, mode }: { source: CreationExploration; filters: CreationFilters; mode: "value" | "count" }) {
  const input = creationChangeWording(source, filters, mode);
  const fallback = <p className="text-sm leading-6 text-gray-600">{input.fallback}</p>;
  return <Suspense fallback={fallback}><WrittenChange {...input} /></Suspense>;
}
